export const normalizeWhitespace = (value: any) => {
  // Remove leading and trailing whitespace
  return value.replace(/^\s+/g, "");
};
